export default import.meta.ROLLUP_FILE_URL_FKNdLzKnlftW3t_gzo81yw;